import React, { useEffect, useState } from "react";
import { Stack, FormControl, Modal, Typography, Divider, TextField, Grid, Box, Card, Table, Button, TableRow, TableBody, TableCell, Container, TableContainer, Select, InputLabel, MenuItem } from '@mui/material';
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import { UserListHead } from '../../sections/@dashboard/user';
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import { useDispatch, useSelector } from "react-redux";
import { CreateFaqAction, GetCategoryList, GetFaqList, ResetCreateFaqAction, ResetGetCategoryList, ResetGetFaqList, ResetUpdateFaqAction, UpdateFaqAction } from "src/redux/actions/CMSActions";
import Loader from "src/components/Loader";
import { toast } from 'react-toastify';
import ReactQuill from 'react-quill';
import "react-quill/dist/quill.snow.css";

const Category = () => {
    const dispatch = useDispatch();
    const CategorySelector = useSelector((state) => state.cms?.catgeory_list?.data?.data);
    const FaqSelector = useSelector((state) => state.cms?.faq_list?.data?.data);
    const FaqCreateSelector = useSelector((state) => state.cms?.create_faq);
    const FaqUpdateSelector = useSelector((state) => state.cms?.update_faq);
    const loadingSelector = useSelector((state) => state.cms.loading);
    const [open, setOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState()
    const [state, setState] = useState({
        faq_id: null,
        category_name: "",
        question: "",
        answer: ""
    });

    useEffect(() => {
        dispatch(GetCategoryList());
        dispatch(GetFaqList());
        return () => {
            dispatch(ResetGetCategoryList())
            dispatch(ResetGetFaqList())
        }
    }, [dispatch]);

    const handleCatEdit = (data) => {
        setState({
            faq_id: data?._id,
            category_name: data?.category_name,
            question: data?.question,
            answer: data?.answer
        });
        handleOpen("Edit")
    };

    const stateHandler = (key, value) => {
        state[key] = value;
        setState({ ...state });
    };

    const handleOpen = (text) => {
        setOpen(true);
        setModalTitle(text);
    };

    const handleClose = () => {
        setOpen(false);
    }

    const handleFaqSubmit = (e) => {
        e.preventDefault();
        if (modalTitle == "Add") {
            dispatch(CreateFaqAction({
                category_name: state?.category_name,
                question: state?.question,
                answer: state?.answer
            }))
            setState({
                faq_id: null,
                category_name: "",
                question: "",
                answer: ""
            });
        } else {
            dispatch(UpdateFaqAction(state))
        }
    };

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "70%",
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4,
    };

    useEffect(() => {
        if (Object.keys(FaqUpdateSelector).length > 0) {
            if (FaqUpdateSelector.data.status) {
                toast.success(FaqUpdateSelector.data.message, { theme: "colored" })
                setOpen(false)
                dispatch(ResetUpdateFaqAction())
                dispatch(GetFaqList());
                setState({
                    faq_id: null,
                    category_name: "",
                    question: "",
                    answer: ""
                });
            } else {
                toast.error(FaqUpdateSelector.data.message, { theme: "colored" })
            }
        }
    }, [FaqUpdateSelector])

    useEffect(() => {
        if (Object.keys(FaqCreateSelector).length > 0) {
            if (FaqCreateSelector.data.status) {
                toast.success(FaqCreateSelector.data.message, { theme: "colored" })
                setOpen(false)
                dispatch(ResetCreateFaqAction())
                dispatch(GetFaqList());
            } else {
                toast.error(FaqCreateSelector.data.message, { theme: "colored" })
            }
        }
    }, [FaqCreateSelector])

    const formats = ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'image'];

    const modules = {
        toolbar: [
            [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
            ['link', 'image'],
            ['clean']
        ]
    };

    return (
        <Page title="FAQs Management">
            {loadingSelector ? <Loader /> : null}

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography
                        id="modal-modal-title"
                        style={{ marginBottom: 20 }}
                        align={"center"}
                        variant="h6"
                        component="h2"
                    > {modalTitle} </Typography>
                    <Divider />

                    <form autoComplete="off" onSubmit={handleFaqSubmit}>
                        <Stack container spacing={3}>
                            <FormControl fullWidth>
                                <InputLabel id="select-category">Select Category *</InputLabel>
                                {CategorySelector?.category_list?.length > 0 &&
                                    <Select
                                        labelId="select-category"
                                        onChange={({ target }) => stateHandler("category_name", target.value)}
                                        id="select-category-id"
                                        label="Select Category"
                                        fullWidth
                                        required
                                        value={state.category_name}
                                    >
                                        {CategorySelector?.category_list?.map((obj, i) => {
                                            return <MenuItem value={obj?.name} key={i}> {obj?.name} </MenuItem>
                                        })}
                                    </Select>
                                }
                            </FormControl>

                            <Grid item md={12}>
                                <TextField
                                    onChange={({ target }) => stateHandler("question", target.value)}
                                    type="text"
                                    label="Question"
                                    variant="outlined"
                                    value={state.question}
                                    fullWidth
                                    required
                                />
                            </Grid>

                            <div className="faq-quill-input">
                                <ReactQuill
                                    className="cms-content-editor"
                                    name="answer"
                                    modules={modules}
                                    formats={formats}
                                    value={state.answer}
                                    onChange={(value) => stateHandler("answer", value)}
                                />
                            </div>

                            {/* <TextField
                                onChange={({ target }) => stateHandler("answer", target.value)}
                                type="text"
                                label="Answer"
                                variant="outlined"
                                value={state.answer}
                                fullWidth
                                required
                                rows={5}
                                multiline
                            /> */}
                        </Stack>
                        <Button
                            align={"center"}
                            style={{ marginTop: 20, width: "100%" }}
                            variant="contained"
                            type="submit"
                        >
                            Submit
                        </Button>
                    </form>

                </Box>
            </Modal>

            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="FAQs Management"
                    links={[
                        { name: "Dashboard", href: "/dashboard/app" },
                        { name: "FAQs Management" },
                    ]}
                    action={
                        <Button
                            variant="contained"
                            // component={RouterLink}
                            onClick={() => handleOpen("Add")}
                        >
                            Add FAQ
                        </Button>
                    }
                />

                <Card>
                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <UserListHead
                                    headLabel={[
                                        { id: 'c_no', label: 'Sr no.', alignRight: false },
                                        { id: 'c_question', label: 'Question', alignRight: false },
                                        { id: 'c_category_name', label: 'Category', alignRight: false },
                                        { id: 'c_answer', label: 'Answer', alignRight: false },
                                        { id: 'c_action', label: 'Actions', alignRight: false }
                                    ]}
                                />
                                <TableBody>
                                    {FaqSelector ?
                                        FaqSelector?.faq_list?.map((data, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell component="th" scope="row"> {index + 1}.</TableCell>
                                                    <TableCell component="th" scope="row">
                                                        {data?.question}
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" style={{ textTransform: "capitalize" }}> {data?.category_name}</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textTransform: "capitalize", width: "50%" }}>
                                                        <div
                                                            dangerouslySetInnerHTML={{ __html: data?.answer }}
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <Button size="small" color="success" onClick={() => {
                                                            handleCatEdit(data)

                                                        }}> Edit </Button>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })
                                        : ""
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>
                </Card>
            </Container>
        </Page>
    );
};

export default Category;
